app.service('configService', ['crudService', function(crudService) {
	var sessionKey = 'assetConfig';
	if(!sessionStorage.getItem(sessionKey)) {
		sessionStorage.setItem(sessionKey, null);
		crudService.get('assets-config.json').then(function (response) {
			sessionStorage.setItem(sessionKey, JSON.stringify(response));
		});
	}

	this.get = function(version) {
		var config = JSON.parse(sessionStorage.getItem(sessionKey));
		if(!config) return null;
		return config[version];
	};

	this.getVersion = function() {
		return this.get('timestamp');
	}
}]);